export default function NotFound() {
    return <div> Página no encontrada  </div>;
  }